module.exports = __webpack_public_path__ + "static/media/edu-exp.3f3f2c43.svg";